import { mount } from "svelte";
import { events } from "../events";
import HcSheet from "./HcSheet.svelte";
import { getElementById } from "../util/Utils";

export { markHcSheetClosed, openHcSheet } from "./hcSheetState.svelte";
export { registerHcFilterSheetHandlers } from "./HcFilterSheetHandlers";
/**
 *
 *
 *
 *
 */
export function registerHcSheet(): void {
  events.onHcSheetRootLoaded(() => {
    const target = getElementById("hc_sheet_root");
    if (target) {
      mount(HcSheet, { target });
    }
  });
}
